<template>
    <div id="changelog">
         <h1>CHANGELOG (VERSION 1.4)</h1>
        <ul>
            <li>Revamped Sign in Page</li>
            <li>Users are now authenticated by Firebase</li>
            <li>Added User info card</li> 
        </ul>
        <h1>CHANGELOG (VERSION 1.3)</h1>
        <ul>
            <li>Fixed duplication of records when added bug</li>
            <li>Added Route guards</li>
            <li>Duplicate Records cannot be created from ver 1.3</li> 
            <li>Added get started button in mobile when book list is empty</li>
        </ul>
        <h1>CHANGELOG (VERSION 1.2)</h1>
        <ul>
           <li>App made responsive</li> 
        </ul>
        <h1>CHANGELOG (VERSION 1.1)</h1>
        <ul>
           <li>Logout Route navigation to signin fixed</li> 
           <li>Input Validation added </li>
           <li>Changed cursor to pointer on hover of search results for both edit and create results</li>
           <li>Search query now displays the full title of the chosen book in the book name field</li>
        </ul>
    </div>
</template>

<script>
export default {
    name: 'Changelog',    
}
</script>

<style scoped>
* {
    text-align: left;
}
</style>
